import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@weave-mui/material';
import { formatRelativeTime } from '../utils/formatRelativeTime';
const RelativeTime = ({ value, variant = 'body1' }) => {
    const exact = new Date(value).toLocaleString();
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Typography, { variant: variant, children: formatRelativeTime(value) }), _jsx(Tooltip, { title: exact, children: _jsx(InfoOutlinedIcon, { sx: { fontSize: 14, color: 'text.disabled', cursor: 'help' } }) })] }));
};
export default RelativeTime;
